import React, { useContext } from "react";
import { ContentContext } from "../contexts/ContentContext";

export default function PartnersSection() {
    const { data } = useContext(ContentContext);

    return (
        <section className="relative py-20 md:py-28 bg-navy-50 overflow-hidden">
            <div className="absolute inset-0 brand-pattern opacity-30 pointer-events-none" />

            <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
                <div className="max-w-2xl mx-auto text-center mb-14">
                    <div className="inline-flex items-center gap-3 mb-4 justify-center">
                        <span className="h-px w-10 bg-gold-500" />
                        <span className="text-xs font-bold text-brand-emerald tracking-[0.22em] uppercase">
                            {data.partners.eyebrow}
                        </span>
                        <span className="h-px w-10 bg-gold-500" />
                    </div>
                    <h2 className="font-serif text-3xl md:text-5xl font-bold text-navy-900 mb-4">
                        {data.partners.title}
                    </h2>
                    <p className="text-lg text-navy-700/80">{data.partners.subtitle}</p>
                </div>

                <div className="bg-white rounded-3xl shadow-card p-8 md:p-12 mb-10 border border-navy-100">
                    <img
                        src="/images/silk-banner.jpg"
                        alt="SILK United — Your Global Reach, Trustable Partner"
                        className="w-full rounded-2xl mb-8"
                        onError={(e) => (e.currentTarget.style.display = "none")}
                    />
                    <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
                        {data.partners.items.map((p, i) => (
                            <div
                                key={i}
                                className="flex flex-col items-center text-center p-6 bg-navy-50/60 rounded-2xl border border-navy-100 hover:border-gold-300 hover:shadow-soft transition"
                            >
                                <div className="h-16 flex items-center justify-center mb-4">
                                    {p.name === "SILK United" && (
                                        <img src="/images/silk-logo.png" alt="SILK" className="h-12 object-contain" onError={(e) => (e.currentTarget.style.display = "none")} />
                                    )}
                                    {p.name === "Ozon" && (
                                        <img src="/images/ozon-logo.png" alt="Ozon" className="h-10 object-contain" onError={(e) => (e.currentTarget.style.display = "none")} />
                                    )}
                                    {(p.name !== "SILK United" && p.name !== "Ozon") && (
                                        <div className="font-serif font-bold text-xl text-navy-900">
                                            {p.name}
                                        </div>
                                    )}
                                </div>
                                <div className="font-serif font-bold text-navy-900 mb-1">
                                    {p.name}
                                </div>
                                <div className="text-xs text-navy-700/70 uppercase tracking-wider">
                                    {p.role}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
